<script setup lang="ts">
import ElementalItemButton from '../ElementalItemButton/index.vue'
import { useElementalFormStore } from '~~/src/stores/elementalForm'
import { type Elemental } from '~~/src/types/elemental'

const props = defineProps<{
  elemental: Elemental
}>()

const { open } = useElementalFormStore()

const user = useUser()

const isOwner = computed(() => user.value?.id === props.elemental.user.id)

const handlerClick = () => {
  open('edit', unref(props.elemental), getElementalType(props.elemental.elementalTypeId, props.elemental.isList))
}
</script>

<template>
  <ElementalItemButton v-if="isOwner" title="Edit item" @click="handlerClick">
    <div i-material-symbols:edit-outline />
  </ElementalItemButton>
</template>
